import { css } from '@emotion/core'

export const btn = css`
  width: 100%;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  border: none;
  border-radius: 22.5px;
  padding: 15px 16px 14px;
  vertical-align: middle;
  text-align: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
  color: #737474;
  border: solid 1px rgba(0, 0, 0, 0.12);
  background-color: rgba(98, 2, 238, 0);
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85625rem;
  font-weight: 600;
  line-height: 1.16;
  letter-spacing: 1.25px;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  transition: box-shadow 0.2s;
  ::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: currentColor;
    opacity: 0;
    transition: opacity 0.2s;
  }
  ::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    padding: 50%;
    width: 32px;
    height: 32px;
    background-color: currentColor;
    opacity: 0;
    transform: translate(-50%, -50%) scale(1) ;
    transition: opacity 1s, transform 0.5s;
  }
  :hover {
    ::before {
      opacity: 0.04;
    }
    :focus {
      ::before {
        opacity: 0.16;
      }
    }
  }
  :focus {
    ::before {
      opacity: 0.12;
    }
  }
  :active {
    ::after {
      opacity: 0.16;
      transform: translate(-50%, -50%) scale(0);
      transition: transform 0s;
    }
  }
  :disabled {
    color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.38);
    background-color: transparent;
    cursor: initial;
    cursor: initial;
    ::before {
      opacity: 0;
    }
    ::after {
      opacity: 0;
    }
  }
`
export const btnLarge = css`
  ${btn};
  max-width: 328px;
`
export const btnMedium = css`
  ${btn};
  max-width: 200px;
`
export const btnMedium_ = css`
  ${btn};
  max-width: 210px;
`
export const btnMediumV = css`
  ${btn};
  max-width: 200px;
  color: #fff;
  border-color: #fff;
`
export const btnSmall = css`
  ${btn};
  max-width: 140px;
`
export const btnLink = css`
  ${btn};
`
export const btnOutlinedNav = css`
  ${btn};
`